import { AwardType } from '../../../../../types/ResumeTypes';

import C from '../ViewerMode.module.scss';
import ResumeInfoPeriod from '../../../../common/ResumeInfoPeriod/index';

interface AwardViewerProps {
  awards: AwardType[];
}

const AwardViewer = (props: AwardViewerProps) => {
  const { awards } = props;

  if (awards === undefined || awards.length === 0) {
    return null;
  }

  return (
    <>
      <section className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>수상사항</h4>
        {awards?.map((award, index) => {
          return <AwardElementViewer award={award} key={`award-viewer-${index}`} />;
        })}
      </section>
      <hr />
    </>
  );
};

interface AwardElementViewerProps {
  award: AwardType;
}

const AwardElementViewer = (props: AwardElementViewerProps) => {
  const { award } = props;

  return (
    <>
      {/* 개별 박스 */}
      <article className={`${C.common_box}`}>
        {/* 기간 */}
        <ResumeInfoPeriod text={award.institution || ''} startDate={award.at || ''} endDate={''} />
        {/* 상세 내용 */}
        <div className={`${C.profile_text_wrap}`}>
          <div className={`${C.profile_text_line}`}>
            <div className={C.text_el_wrap}>
              <h2 className="h2">{award.name}</h2>
            </div>
          </div>
          <div className={C.profile_text_line}>
            <div className={C.text_el_wrap}>
              <h4 className="b1">{award.description}</h4>
            </div>
          </div>
        </div>
      </article>
      {/* 개별 박스 */}
      {/*<article className={`${C.common_box} vertical-center`}>*/}
      {/*  /!* 기간 *!/*/}
      {/*  <ResumeInfoPeriod text="장려상" startDate="2020.10" endDate="2023.02" />*/}
      {/*  /!* 상세 내용 *!/*/}
      {/*  <div className={`${C.profile_text_wrap}`}>*/}
      {/*    <div className={`${C.profile_text_line}`}>*/}
      {/*      <div className={C.text_el_wrap}>*/}
      {/*        <h2 className="h2">수상명</h2>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className={C.profile_text_line}>*/}
      {/*      <div className={C.text_el_wrap}>*/}
      {/*        <h4 className="b1">*/}
      {/*          - 상세내용 <br />- 상세내용*/}
      {/*        </h4>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</article>*/}
    </>
  );
};

export default AwardViewer;
